export function setSessionStore(key: string, value: any) {
  // Avoid persisting the literal string "undefined" (JSON.stringify(undefined) => undefined)
  if (value === undefined) {
    sessionStorage.removeItem(key);
    return;
  }

  const serialized = JSON.stringify(value);
  // JSON.stringify can return undefined for unsupported values (e.g. functions, symbols)
  if (serialized === undefined) {
    sessionStorage.removeItem(key);
    return;
  }

  sessionStorage.setItem(key, serialized);
}

export function getSessionStore(key: string) {
  const raw = sessionStorage.getItem(key);

  if (!raw || raw === "undefined") {
    return {};
  }

  try {
    return JSON.parse(raw);
  } catch {
    return {};
  }
}

export function removeSessionStore(key: string) {
  sessionStorage.removeItem(key);
}

export function clearSessionStore() {
  sessionStorage.clear();
}

export function setObjectInSessionStore(key: string, object: object) {
  setSessionStore(key, object);
}

export function getObjectFromSessionStore(key: string) {
  try {
    const objectString = getSessionStore(key);
    return objectString;
  } catch (e) {
    return {};
  }
}
